import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4650948e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "icon-chevron-left" }, null, -1))

import {computed} from 'vue';
	import {useRoute} from 'vue-router';
	import {pageHelper} from '@/utils/pageHelper';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'BackLink',
  setup(__props) {

	const route = useRoute();

	const backLink = computed(() => {
		const url = route.meta?.backLink?.url;
		if (url && typeof url === 'function') {
			return url(route);
		}
		return {name: url ?? pageHelper.PAGE_MY_COMPANIES};
	});
	const backLinkLabel = computed(() => route.meta?.backLink?.label ?? 'vorige pagina');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: backLink.value,
    "active-class": "",
    class: "back-link"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("  Terug naar " + _toDisplayString(backLinkLabel.value), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})